module.exports = __webpack_public_path__ + "../resources/img/ic-re-zoomout.8a9e3ba7.svg";